import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { CropDTO } from "../dtos/CropDTO";
import { STALE_TIME_LONG } from "../queries/query.constants";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { computed } from "vue";
const CROPS_STALE_TIME = STALE_TIME_LONG;
// Crops for the current customer
export function useCrops() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["crops"],
        queryFn: async () => (await seedgreenAPI.get("v2/Crop")).data,
        staleTime: CROPS_STALE_TIME,
        select: (data) => data?.map((crop) => new CropDTO(crop)) ?? [],
    });
    return {
        crops: query.data,
        cropsById: computed(() => _.keyBy(query.data.value, "id")),
        ...query,
    };
}
